<span class="ddp-box-tag-value" [ngClass]="getMetadataTypeIcon()">
  {{ getMetadataType() }}
</span>
